module.exports = __webpack_public_path__ + "img/topics4.e23b3940.png";